<template>
    <b-dropdown text="Actions"
                size="sm"
                variant="primary-user"
                class="dropdown-split-arrow">
        <b-dropdown-item :to="{name: 'SingleProduct', params: {id: productId}}">Edit</b-dropdown-item>
        <b-dropdown-item disabled>Copy</b-dropdown-item>
        <b-dropdown-item disabled>Notifications</b-dropdown-item>
        <b-dropdown-item @click="archiveProduct">
            Archive</b-dropdown-item>
        <b-dropdown-item @click="deleteProduct">Remove</b-dropdown-item>
    </b-dropdown>
</template>

<script>
    export default {
        name: 'ProductActions',
        props: {
            productId: {
                type: Number,
                required: true
            },
            updateList: {
                type: Function,
                required: true
            }
        },
        methods: {
            deleteProduct() {
                this.$store.dispatch('deleteProduct', this.productId)
                    .then(() => this.updateList())
            },
            archiveProduct() {
                this.$store.dispatch('productActions', this.$endpoints.addToArchive(this.productId))
                    .then(() => this.updateList())
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Management/ProductActions.vue